/* The Funding Engine's home (FEHome.dc.html at 1440). No board draws it on a phone or in the widths
   between, so there it takes PhoneWeek.dc.html's pieces: 16px gutters, cards with 14px corners,
   Anton headings at phone size, buttons the whole width. Colours are the tokens file's only. It sits
   inside the product frame's .pp--fe look (product.css), which sets the page, the gutter and the
   footer. */

/* The Funding Engine's product boards (FEHome, FEWeek, PhoneWeek, Certificate) set body text in
   Archivo at 400, where Login.dc.html loads Archivo from 500 only, so the /funding-engine door's 400
   text renders at 500 (fonts.css). The 400 face is registered under its own family, with the same
   files as fonts.css for 500 to 800, and used only inside the product's look, so the door keeps
   rendering as the board does (stage 4 review). */
@font-face {
  font-family: 'Archivo Text'; font-style: normal; font-display: swap; font-weight: 400;
  src: url(../../node_modules/@fontsource/archivo/files/archivo-latin-400-normal.woff2) format('woff2'),
    url(../../node_modules/@fontsource/archivo/files/archivo-latin-400-normal.woff) format('woff');
}
@font-face {
  font-family: 'Archivo Text'; font-style: normal; font-display: swap; font-weight: 500;
  src: url(../../node_modules/@fontsource/archivo/files/archivo-latin-500-normal.woff2) format('woff2'),
    url(../../node_modules/@fontsource/archivo/files/archivo-latin-500-normal.woff) format('woff');
}
@font-face {
  font-family: 'Archivo Text'; font-style: normal; font-display: swap; font-weight: 600;
  src: url(../../node_modules/@fontsource/archivo/files/archivo-latin-600-normal.woff2) format('woff2'),
    url(../../node_modules/@fontsource/archivo/files/archivo-latin-600-normal.woff) format('woff');
}
@font-face {
  font-family: 'Archivo Text'; font-style: normal; font-display: swap; font-weight: 700;
  src: url(../../node_modules/@fontsource/archivo/files/archivo-latin-700-normal.woff2) format('woff2'),
    url(../../node_modules/@fontsource/archivo/files/archivo-latin-700-normal.woff) format('woff');
}
@font-face {
  font-family: 'Archivo Text'; font-style: normal; font-display: swap; font-weight: 800;
  src: url(../../node_modules/@fontsource/archivo/files/archivo-latin-800-normal.woff2) format('woff2'),
    url(../../node_modules/@fontsource/archivo/files/archivo-latin-800-normal.woff) format('woff');
}
.pp--fe { --fe-body-font: 'Archivo Text', 'Archivo', system-ui, sans-serif; }

.fe-home { display: flex; flex-direction: column; min-width: 0; }
.fe-home--loading { min-height: 50vh; }
.fe-home-layout { gap: 44px; }
/* the 2 cards of a band are the same height, as on the board: the session beside the week to catch
   up on (40px apart), Still to tick beside Stuck on anything (24px apart) */
.fe-home-layout .pp-band { gap: 24px; align-items: stretch; }
.fe-home-layout .pp-band:has([data-section='next']) { gap: 40px; }
.fe-home-layout .pp-band-col > .pp-section:only-child { flex: 1; display: flex; flex-direction: column; }
.fe-home-layout .pp-band-col > .pp-section:only-child > section { flex: 1; }

.fe-eyebrow { font-size: 14px; font-weight: 600; letter-spacing: 0.14em; text-transform: uppercase; color: var(--fe-muted); }
.fe-h2 { margin: 0; font-family: var(--fe-heading-font); font-weight: 400; font-size: 32px; letter-spacing: 0.02em; text-transform: uppercase; }
.fe-h3 { margin: 0; font-family: var(--fe-heading-font); font-weight: 400; font-size: 22px; letter-spacing: 0.02em; text-transform: uppercase; }
.fe-msg { margin: 0; font-size: 14px; line-height: 1.5; color: var(--fe-text); }

/* The next live session */
.fe-hero {
  padding: 40px; border-radius: 18px; background: var(--fe-surface); border: 1px solid var(--on-dark-12);
  display: flex; flex-direction: column; gap: 18px; min-width: 0;
}
.fe-hero-h1 {
  margin: 0; font-family: var(--fe-heading-font); font-weight: 400; font-size: 76px; line-height: 1;
  letter-spacing: 0.01em; text-transform: uppercase;
}
.fe-hero-lede { margin: 0; font-size: 18px; line-height: 1.55; color: var(--fe-muted); max-width: 620px; }
.fe-hero-actions { display: flex; gap: 12px; margin-top: 6px; flex-wrap: wrap; }
.fe-join {
  height: 52px; padding: 0 22px; border-radius: 10px; background: var(--fe-green-22); color: var(--fe-text);
  font-weight: 700; font-size: 16px; display: inline-flex; align-items: center; gap: 10px; text-decoration: none; white-space: nowrap;
}
.pp .fe-join { color: var(--fe-text); }
.pp .fe-join--open { background: var(--fe-green); color: var(--fe-on-green); }
.fe-cal {
  height: 52px; padding: 0 20px; border-radius: 10px; border: 1px solid var(--on-dark-28); background: transparent;
  color: var(--fe-text); font-weight: 700; font-size: 16px; white-space: nowrap;
}

/* Where they are: "Catch up first" beside the session */
.fe-lead {
  padding: 32px; border-radius: 18px; border: 1px solid var(--on-dark-12);
  display: flex; flex-direction: column; gap: 18px; min-width: 0;
}
.fe-lead-title { margin: 0; font-family: var(--fe-heading-font); font-weight: 400; font-size: 30px; line-height: 1.1; text-transform: uppercase; }
.fe-lead-where { display: flex; flex-direction: column; gap: 8px; }
.fe-bar { display: block; height: 6px; border-radius: 3px; background: var(--on-dark-12); overflow: hidden; }
.fe-bar span { display: block; height: 6px; border-radius: 3px; background: var(--fe-green); }
.fe-lead-line { font-size: 15px; line-height: 1.4; color: var(--fe-muted); }
.fe-lead-btn {
  height: 48px; padding: 0 20px; border-radius: 10px; background: var(--fe-green); font-weight: 700; font-size: 16px;
  display: flex; align-items: center; justify-content: center; gap: 8px; text-decoration: none; white-space: nowrap;
}
.pp .fe-lead-btn { color: var(--fe-on-green); }
/* With no session to come it leads the page, in the session's place and at its size */
.fe-lead--main { padding: 40px; background: var(--fe-surface); }
.fe-lead--main .fe-lead-title { font-size: 68px; line-height: 1; letter-spacing: 0.01em; }
.fe-lead--main .fe-lead-where { max-width: 620px; margin-top: 4px; }
.fe-lead--main .fe-lead-line { font-size: 18px; line-height: 1.55; }
.fe-lead--main .fe-lead-btn { align-self: flex-start; height: 52px; padding: 0 22px; margin-top: 6px; }
/* the recording's 16:9 frame at the top of the card, once any recording has a thumbnail (decision 47):
   the side column's width beside the session, and no wider than 440px where the card spans the page (the
   session above it, below 1100px), so its words and button stay near the top */
.fe-lead-thumb { --rthumb-radius: 12px; }
.fe-lead .thumb.fe-lead-thumb { max-width: 440px; }
.fe-lead--main .thumb.fe-lead-thumb { width: 440px; max-width: 100%; }

/* Your 6 weeks */
.fe-weeks { display: flex; flex-direction: column; gap: 16px; }
.fe-wk-list { border-radius: 16px; border: 1px solid var(--on-dark-12); overflow: hidden; }
.fe-wk {
  display: grid; grid-template-columns: 120px 150px minmax(0, 1fr) 260px 120px; gap: 20px; align-items: center;
  padding: 20px 28px; border-bottom: 1px solid var(--on-dark-08);
}
.fe-wk:last-child { border-bottom: none; }
.fe-wk:hover { background: var(--on-dark-04); }
.fe-wk-list--nodates .fe-wk { grid-template-columns: 120px minmax(0, 1fr) 260px 120px; }
.fe-wk-head, .fe-wk-main { display: contents; }
.fe-wk-label { font-family: var(--fe-heading-font); font-size: 22px; letter-spacing: 0.02em; text-transform: uppercase; color: var(--fe-text); }
.fe-wk-date { font-size: 15px; color: var(--fe-muted); }
.fe-wk-title { font-size: 17px; font-weight: 600; min-width: 0; }
.fe-wk-status { display: flex; align-items: center; gap: 8px; font-size: 14px; line-height: 1.4; color: var(--fe-text); }
.fe-wk-status .icon-line { color: var(--fe-green); flex-shrink: 0; }
.fe-wk--carry .fe-wk-status { color: var(--fe-gold); }
.fe-wk--live .fe-wk-label, .fe-wk--live .fe-wk-status { color: var(--fe-green); }
.fe-wk--later .fe-wk-label, .fe-wk--later .fe-wk-status, .fe-wk--soft .fe-wk-status { color: var(--fe-muted); }
.fe-wk-open {
  justify-self: end; height: 40px; padding: 0 16px; border-radius: 10px; border: 1px solid var(--on-dark-28);
  font-weight: 700; font-size: 14px; display: flex; align-items: center; text-decoration: none;
}
.pp .fe-wk-open { color: var(--fe-text); }
.pp .fe-wk-open:hover { border-color: var(--fe-green); }
.fe-wk-action { justify-self: end; font-size: 14px; color: var(--fe-muted); }
/* each week's recording frame in front of its row, once any recording has a thumbnail (decision 47) */
.fe-wk-list--thumbs .fe-wk { grid-template-columns: 112px 110px 140px minmax(0, 1fr) 220px 120px; }
.fe-wk-list--thumbs.fe-wk-list--nodates .fe-wk { grid-template-columns: 112px 110px minmax(0, 1fr) 220px 120px; }
.fe-wk-thumb { --rthumb-radius: 8px; }
.fe-wk-thumb .rthumb-date { font-size: 10px; }
.fe-wk-thumb .rthumb-day { font-size: 18px; }

/* Still to tick, and Stuck on anything */
.fe-card { padding: 28px; border-radius: 16px; border: 1px solid var(--on-dark-12); display: flex; flex-direction: column; gap: 14px; min-width: 0; }
.fe-card--fill { background: var(--fe-surface); }
.fe-tick { display: flex; gap: 12px; align-items: flex-start; font-size: 15px; line-height: 1.5; cursor: pointer; }
.fe-tick input { width: 20px; height: 20px; margin: 2px 0 0; accent-color: var(--fe-green); flex-shrink: 0; }
.fe-tick-text { color: var(--fe-text); }
.fe-tick--done .fe-tick-text { color: var(--fe-muted); }
.fe-help-text { margin: 0; font-size: 16px; line-height: 1.55; color: var(--fe-muted); }
.fe-help-link {
  align-self: flex-start; display: flex; align-items: center; gap: 10px; font-size: 15px; font-weight: 700;
  text-decoration: none; overflow-wrap: anywhere;
}
.pp .fe-help-link { color: var(--fe-green); }
.pp .fe-help-link:hover { color: var(--fe-text); }

/* Between a laptop and a phone: 1 column in the layout's order (Layout.jsx), each week's title over
   its status */
@media (max-width: 1099px) {
  .fe-hero-h1 { font-size: 60px; }
  .fe-lead--main .fe-lead-title { font-size: 56px; }
  .fe-wk { grid-template-columns: 100px 110px minmax(0, 1fr) auto; }
  .fe-wk-list--nodates .fe-wk { grid-template-columns: 100px minmax(0, 1fr) auto; }
  .fe-wk-main { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
  .fe-wk-list--thumbs .fe-wk { grid-template-columns: 96px 100px 110px minmax(0, 1fr) auto; }
  .fe-wk-list--thumbs.fe-wk-list--nodates .fe-wk { grid-template-columns: 96px 100px minmax(0, 1fr) auto; }
}

/* A phone */
@media (max-width: 760px) {
  .fe-home-layout { gap: 22px; }
  .fe-eyebrow { font-size: 12px; }
  .fe-hero, .fe-lead--main { padding: 22px 18px; border-radius: 14px; gap: 14px; }
  .fe-hero-h1, .fe-lead--main .fe-lead-title { font-size: 40px; line-height: 1.02; }
  .fe-hero-lede, .fe-lead--main .fe-lead-line { font-size: 15px; }
  .fe-hero-actions { flex-direction: column; gap: 10px; margin-top: 2px; }
  .fe-join, .fe-cal, .fe-lead--main .fe-lead-btn { height: 48px; justify-content: center; align-self: stretch; }
  .fe-lead--main .fe-lead-btn { margin-top: 2px; }
  .fe-lead { padding: 20px 16px; border-radius: 14px; gap: 14px; }
  .fe-lead-title { font-size: 26px; }
  .fe-h2 { font-size: 24px; }
  .fe-weeks { gap: 12px; }
  .fe-wk-list { border-radius: 14px; }
  .fe-wk, .fe-wk-list--nodates .fe-wk {
    grid-template-columns: minmax(0, 1fr) auto; grid-template-areas: 'head action' 'main action';
    gap: 4px 12px; padding: 14px 16px;
  }
  .fe-wk-head { display: flex; align-items: baseline; gap: 10px; grid-area: head; }
  .fe-wk-main { grid-area: main; }
  .fe-wk-open, .fe-wk-action { grid-area: action; align-self: center; }
  .fe-wk-list--thumbs .fe-wk, .fe-wk-list--thumbs.fe-wk-list--nodates .fe-wk {
    grid-template-columns: 88px minmax(0, 1fr) auto; grid-template-areas: 'thumb head action' 'thumb main action';
  }
  .fe-wk-thumb { grid-area: thumb; align-self: center; --rthumb-radius: 6px; }
  .fe-wk-thumb .rthumb-day { font-size: 16px; }
  /* beside the frame a week's label and its date each stay whole: where both don't fit on 1 line, the date
     goes under the label */
  .fe-wk-list--thumbs .fe-wk-head { flex-wrap: wrap; row-gap: 2px; }
  .fe-wk-list--thumbs .fe-wk-label, .fe-wk-list--thumbs .fe-wk-date { white-space: nowrap; }
  .fe-lead .thumb.fe-lead-thumb { max-width: 100%; }
  .fe-lead--main .thumb.fe-lead-thumb { width: 100%; }
  .fe-wk-label { font-size: 18px; }
  .fe-wk-date { font-size: 13px; }
  .fe-wk-title { font-size: 15px; }
  .fe-wk-status { font-size: 13px; }
  .fe-card { padding: 20px 16px; border-radius: 14px; }
  .fe-h3 { font-size: 20px; }
  .fe-tick { font-size: 14px; }
  .fe-tick input { width: 22px; height: 22px; margin-top: 1px; }
  .fe-help-text { font-size: 14px; }
}

/* A narrow phone (360 to 399, the iPhone SE and mini among them): a smaller frame, so each week's label and
   date still fit on 1 line beside it, its panel the date and the month as the search's hits show it */
@media (max-width: 399px) {
  .fe-wk-list--thumbs .fe-wk, .fe-wk-list--thumbs.fe-wk-list--nodates .fe-wk { grid-template-columns: 64px minmax(0, 1fr) auto; }
  .fe-wk-thumb .rthumb-date { gap: 0; font-size: 9px; letter-spacing: 0.06em; }
  .fe-wk-thumb .rthumb-edge:first-child { display: none; }
  .fe-wk-thumb .rthumb-day { font-size: 14px; }
}
